/**
 * A custom wrapper for lodash.orderby that makes the order case insensitive, and orders falsies first
 */
import orderBy from 'lodash.orderby';
import get from 'lodash.get';

const formatIteratee = (iteratee) => (value) => {
    const propertyValue = get(value, iteratee);
    if (typeof propertyValue === 'string') {
        return propertyValue.toLowerCase();
    }
    return propertyValue || '';
};

const formatIterateeFn = (iterateeFn) => (value) => {
    const propertyValue = iterateeFn(value);
    if (typeof propertyValue === 'string') {
        return propertyValue.toLowerCase();
    }
    return propertyValue || '';
};

export default function (collection, iteratees, orders) {
    let customIteratees;
    if (typeof iteratees === 'string') {
        customIteratees = formatIteratee(iteratees);
    } else if (Array.isArray(iteratees)) {
        customIteratees = iteratees.map((iteratee) => formatIteratee(iteratee));
    } else if (typeof iteratees === 'function') {
        customIteratees = formatIterateeFn(iteratees);
    } else {
        customIteratees = iteratees;
    }

    return orderBy(collection, customIteratees, orders);
}
